<plyca-ui-collapsable-panel
  [config]="{
    header: 'Title Example',
    collapsed: true,
    toggleable: true,
    collapseIcon: 'fas fa-chevron-down',
    expandIcon: 'fas fa-chevron-up'
  }"
>
  <div class="border rounded p-3 bg-light">
    <h1>Panel expanded!</h1>
  </div>
</plyca-ui-collapsable-panel>
